import { defineMessages } from 'react-intl';

export default defineMessages({
  DEFAULT_SEARCH_PLACEHOLDER: {
    defaultMessage: 'Rechercher',
  },
});
